/** @format */
import React from 'react';
import withCartHandler from './with_cart_handler';
import {ORDER_STATUS_QUOTE, PRODUCT_TYPE_CARTON, PRODUCT_TYPE_LABEL} from 'frontier-constants';
import {CheckoutProcess} from 'frontier/cart/components/cart/checkout_process';
import {CartOverviewSummary} from 'frontier/cart/components/cart_overview/cart_overview_summary';

// style
import './container.sass';
import {Loading} from 'frontier-utilities';
import {CartCheckoutContext} from 'frontier/cart/components/cart/cart_checkout_context';

const SHIPPING_STEP = 0;
const PAYMENT_STEP = 1;

class CartContainer extends React.Component {
    static contextType = CartCheckoutContext;

    render() {
        if (this.context.loading) {
            return (
                <div className="bs4 bs4-utils bs4-grid ">
                    <Loading
                        message="Gathering Order Information..."
                        messageSize="22px"
                        height="50vh"
                    />
                </div>
            );
        }

        if (this.context.orders.some(o => o.status_id === ORDER_STATUS_QUOTE)) {
            // Some orders are still in draft, don't proceed
            return (
                <div style={{textAlign: 'center', marginTop: '50px'}}>
                    <h2>Orders in your cart need your attention</h2>
                    <p>Please return to your orders for review</p>
                    <a className="btn review-btn" href="/orders/custom-labels">
                        Review
                    </a>
                </div>
            );
        }

        return (
            <div
                id="checkout-124972"
                className="checkout-container d-flex align-items-start justify-content-between">
                <div className="checkout-process">
                    <CheckoutProcess />
                </div>
                <div className="cart-overview-summary">
                    <CartOverviewSummary fromCheckout />
                </div>
            </div>
        );
    }
}

export default withCartHandler(CartContainer);
